export const ZendeskArticleContext = {
  // Contexts for ZENDESK_ARTICLE_OPENED event (successful openings)
  OPENED_VIA_SSO: "OPENED_VIA_SSO",
  OPENED_DIRECTLY_SSO_DISABLED: "OPENED_DIRECTLY_SSO_DISABLED",
  OPENED_DIRECTLY_NO_JWT: "OPENED_DIRECTLY_NO_JWT",

  // Contexts for ZENDESK_ARTICLE_OPENED_ERROR event (error scenarios)
  FAILED_TO_FETCH_SSO_TOKEN: "FAILED_TO_FETCH_SSO_TOKEN",
  FAILED_TO_OPEN_BROWSER_WITH_SSO_URL: "FAILED_TO_OPEN_BROWSER_WITH_SSO_URL",
  FAILED_TO_OPEN_BROWSER_DIRECTLY_WHEN_SSO_DISABLED:
    "FAILED_TO_OPEN_BROWSER_DIRECTLY_WHEN_SSO_DISABLED",
  FAILED_TO_OPEN_BROWSER_DIRECTLY_WHEN_NO_JWT: "FAILED_TO_OPEN_BROWSER_DIRECTLY_WHEN_NO_JWT",
  ZENDESK_SSO_CALLBACK_ERROR: "ZENDESK_SSO_CALLBACK_ERROR", // Error from Zendesk redirect processed by SsoBridge
  ZENDESK_SSO_BRIDGE_MISSING_RETURN_TO_URL: "ZENDESK_SSO_BRIDGE_MISSING_RETURN_TO_URL", // return_to missing in SsoBridge
};
